import React, { Component } from 'react'
import { connect } from 'react-redux'
import { sort } from '@adalo/utils'

import {
  getSelection,
  getHoverSelection,
  setLayersHover,
  setSelection,
} from 'ducks/editor/selection'

import { selectObjects, getPath } from 'ducks/editor/objects'
import { setActiveTab, setActiveAddTab } from 'ducks/editor/tabs'
import { getApp } from 'ducks/apps'

import EmptyState from 'components/Shared/EmptyState'
import Icon from 'components/Shared/Icon'
import { PanelItem } from 'components/Shared/Panel'

import { getScreenIcon } from 'utils/icons'

class LayersMenu extends Component {
  handleClick = async () => {
    const { setActiveTab, setActiveAddTab } = this.props
    await setActiveAddTab('screen')

    return setActiveTab('add')
  }

  renderScreens = () => {
    const { app, objects, setLayersHover, setSelection } = this.props

    if (!app || objects.length === 0) {
      return <EmptyState>Nothing drawn yet</EmptyState>
    }

    const { authComponentId, launchComponentId } = app

    // sort objects A-Z by name
    const sorted = sort(objects, obj => obj.name)

    return sorted.map(object => {
      const { id, name } = object

      const icon = getScreenIcon(id, authComponentId, launchComponentId)
      const handleMouseEnter = () => setLayersHover(id)
      const handleMouseLeave = () => setLayersHover(null)
      const handleClick = () => setSelection(id)

      return (
        <PanelItem
          key={id}
          content={name}
          title={name}
          icon={icon}
          fluid
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
        />
      )
    })
  }

  render() {
    return (
      <div className="layers-wrapper">
        <h2 className="left-panel-title">
          <Icon type="screens" /> Screens
        </h2>

        {this.renderScreens()}

        <PanelItem
          title="Add Screen"
          icon="plus"
          color="screens"
          uppercase
          fluid
          onClick={this.handleClick}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, { appId }) => {
  return {
    app: getApp(state, appId),
    objects: selectObjects(state),
    selection: getSelection(state).map(id => getPath(state, id)),
    hoverSelection: getHoverSelection(state).map(id => getPath(state, id)),
  }
}

const mapDispatchToProps = {
  setActiveTab,
  setActiveAddTab,
  setLayersHover,
  setSelection,
}

const ConnectedLayersMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(LayersMenu)

export default ConnectedLayersMenu
